<template>
  <div class="flex space-x-3 items-center mr-8 rounded border p-1 shadow-sm">
    <div class="flex items-center space-x-1 text-sm font-semibold mx-2 text-primary">
      <base-icon icon="users" />
      <span> {{ $store.getters['auth/currentUser'].email }}</span>
    </div>
    <base-button
      size="sm"
      :loading="loading"
      context="secondary"
      class="mr-2"
      action="stop_impersonate"
      @click="onStopImpersonate"
    >
    </base-button>
  </div>
</template>

<script>
import {BaseButton, BaseIcon} from '@/components/base'
export default {
  data() {
    return {
      loading: false,
    }
  },
  components: {
    BaseButton,
    BaseIcon,
  },
  methods: {
    async onStopImpersonate() {
      this.loading = true
      await this.$store.dispatch('auth/stopImpersonate')
      if (this.$route.name === 'Dashboard') {
        this.$router.go()
        this.loading = false
        return
      }
      this.$router.push({name: 'Dashboard', replace: true})
      this.loading = false
    },
  },
}
</script>

<style></style>
